import React from 'react';
import { StyledErrorText, StyledStatusIcon } from './styles';
import { defaultTranslateFn } from "../../common";
export const FileUploadListItemFileInfoErrorMessage = ({ file, translateFn = defaultTranslateFn }) => {
    const styledStatusIcon = file.status && file.status.type ? (React.createElement(StyledStatusIcon, { className: `mi-icon-${file.status.type}` })) : null;
    return file.status ? (React.createElement(StyledErrorText, null,
        styledStatusIcon,
        translateFn(file.status.message, { fileName: file.fileName }))) : null;
};
//# sourceMappingURL=FileUploadListItemFileInfoErrorMessage.js.map